import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './TikTokTooltip.css';

function TikTokTooltip() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`tiktok-tooltip-overlay ${isVisible ? 'visible' : ''}`}>
      <div className="tiktok-tooltip">
        <div className="tooltip-content">
          <div className="tooltip-text">
            <span className="tooltip-text-regular">{t('tiktokTooltip.onText')}</span>
            <img src="/assets/tiktok/tiktok.svg" alt="TikTok" className="tooltip-icon" />
            <span className="tooltip-text-regular">{t('tiktokTooltip.needToTap')}</span>
            <img src="/assets/tiktok/more.svg" alt="More" className="tooltip-icon" />
            {t('tiktokTooltip.andThenTap')} <span className="tooltip-text-highlight">"{t('tiktokTooltip.openInBrowser')}"</span> {t('tiktokTooltip.toDownload')}
          </div>
        </div>
        <img src="/assets/tiktok/caret.svg" alt="" className="tooltip-caret" />
      </div>
    </div>
  );
}

export default TikTokTooltip;